module.exports = __webpack_public_path__ + "media/images/product_owners/peo_sw_90-747310348f6bea2091090967533b1e31.png";